import { isDesktop } from '@/consts/device';
import { getContext } from '@/context';

const closeChooser = () => {
  if (isDesktop) return;

  return getContext().handlers.publishEvent({
    event: 'CollapseWebEditorSidebar',
  });
};

export default closeChooser;
